import { render, staticRenderFns } from "./FastShopping.vue?vue&type=template&id=28f7c802&scoped=true"
import script from "./FastShopping.vue?vue&type=script&lang=js"
export * from "./FastShopping.vue?vue&type=script&lang=js"
import style0 from "./FastShopping.vue?vue&type=style&index=0&id=28f7c802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f7c802",
  null
  
)

export default component.exports